export default {
  name: 'customDetector',

  lookup() {
    var lang = window.location.pathname.split('/')[1]
    return lang
  },
}
